import Image from 'next/image'

import FavoriteButton from '@components/FavoriteButton'
import { slugify } from '@lib/hooks/use-slugify'
import LocalizedClientLink from '@modules/common/components/localized-client-link'

import UndefinedImage from '../../public/undefined-destination.webp'
import { useParams } from 'next/navigation'

export default function ExperienceCard({ experience, user_token = '' }) {
  let slug = `${slugify(experience.title)}-${experience.id}`
  if (experience.metadata?.slug && experience.metadata?.slug_parent) {
   slug = `/bulles-vertes/${slugify(experience.metadata.slug_parent) ?? ''}/${slugify(experience.metadata.slug) ?? ''}`
  }else{
    if (experience.metadata?.slug) {
           slug = `/experience/${slugify(experience.metadata.slug) ?? ''}`

    }else{
    slug = `/experience/${slugify(experience.title) ?? ''}-${experience.id}`

    }
  }
 
  const { countryCode } = useParams()


  return (
    <div className="relative">
      <LocalizedClientLink
        className="relative isolate flex h-[275px] w-full flex-col justify-between gap-3 overflow-hidden rounded p-4 shadow-lg transition hover:scale-[1.02]"
        href={slug}
      >
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <Image
            src={
              (experience.metadata?.thumbnail_url as string) ?? UndefinedImage
            }
            alt={experience.title || 'Expérience'}
            className="h-full w-full object-cover"
            width={400}
            height={400}
          />
          <div className="bg-gradient-overlay-2 absolute inset-0 z-[49]" />
        </div>

        <div>
          <h2
            className={
              'mb-1 line-clamp-2 font-playfairDisplay-bold-italic text-[22px] font-normal leading-tight text-white'
            }
          >
            {experience.title} 
          </h2>
          <p className={'font-roboto text-[16px] text-white'}>
            {experience.metadata?.locale && experience.metadata?.locale[countryCode]?.place_name || experience.metadata?.place_name as string}
          </p>
        </div>

        <div className="relative mt-2 flex flex-col gap-2">
          <div className="flex max-w-[80%] flex-wrap gap-2">
            {(() => {
              const timeLength = (
                countryCode !== 'fr'
                  ? (experience.metadata?.locale?.[countryCode]?.time_length ||
                      experience.metadata?.time_length)
                  : experience.metadata?.time_length
              ) as string | undefined

              if (!timeLength || timeLength.trim() === '-') return null

              return (
                <div className="w-fit rounded-2xl bg-green px-4 py-1 text-sm text-white">
                  <p>{timeLength}</p>
                </div>
              )
            })()}

            {(() => {
              const priceText = (
                countryCode !== 'fr'
                  ? (experience.metadata?.locale?.[countryCode]?.price_text ||
                      experience.metadata?.price_text)
                  : experience.metadata?.price_text
              ) as string | undefined

              if (!priceText || priceText.trim() === '-') return null

              return (
                <div className="w-fit rounded-2xl bg-green px-4 py-1 text-sm text-white">
                  <p>{priceText}</p>
                </div>
              )
            })()}
          </div>
        </div>
      </LocalizedClientLink>

      {/* Heart icon always in bottom right */}
      <div className="absolute bottom-4 right-4">
        <FavoriteButton
          className="flex w-fit rounded-full border-2 border-white bg-black/20 backdrop-blur-sm"
          documentId={experience.metadata.strapi_document_id}
          medusaId={experience?.id}
          documentType="experience"
          authenticated={!!user_token}
          clickable={true}
        />
      </div>
    </div>
  )
}


